import React from 'react'
import OrdinalFrame from 'semiotic/lib/OrdinalFrame'

import toProperCase from './toProperCase'

const frameProps = {
  size: [960, 500],
  margin: { top: 10, right: 0, bottom: 40, left: 100 },
  type: 'bar',
  oPadding: 120,
  oLabel: (d, _series, i) => {
    // custom offsets for each series item based on the test width
    const xTransforms = [-38, -54, -50]
    return (
      <text transform={`translate(${xTransforms[i]},6)`}>{`${toProperCase(
        d
      )}`}</text>
    )
  },
  pieceHoverAnnotation: true
}

export default props => {
  const { data, oKey, rKey, colorKey, colorHash, tooltipContent } = props

  frameProps.data = data
  frameProps.oAccessor = oKey
  frameProps.rAccessor = rKey
  frameProps.style = d => ({ fill: colorHash[d[colorKey]], stroke: 'white' })
  frameProps.axes = [
    {
      orient: 'left'
    }
  ]
  if (tooltipContent) {
    // use custom tooltip content if supplied
    // by the parent component
    frameProps.tooltipContent = tooltipContent
  } else {
    frameProps.tooltipContent = d => (
      <div className="tooltip-content">
        <p>{`${colorKey}: ${d[colorKey]}`}</p>
        <p>{`${rKey}: ${d[rKey]}`}</p>
        <p>{`${oKey}: ${d[oKey]}`}</p>
      </div>
    )
  }

  return <OrdinalFrame {...frameProps} />
}
